import { CSSProperties } from 'react';
import { COLORS } from '../../config/theme/baseTheme';

export const container: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: COLORS.OVERLAY_BACKGROUND,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
  flexDirection: 'column'
};
